<template>
  <div class="flex flex-col h-screen">
    <div class="layout">
      <LayoutSidebar
        class="layout-sidebar flex-shrink-0 p-2"
        :rootRouteName="rootRouteName"
      />
      <div class="layout-content">
        <ClientCabinetMobileHeader
          class="mobile-header"
          @toggle-menu="toggleMobileSidebar"
        />
        <header v-if="hasBreadcrumbs" class="layout-header">
          <LayoutHeader
            :rootRouteName="rootRouteName"
            :navbarSourceRoute="navbarSourceRoute"
            :active-page-title="activePageTitle"
          />
        </header>
        <main class="layout-main">
          <router-view />
        </main>
      </div>
    </div>

    <Drawer v-model:open="showMobileSidebar" direction="left">
      <DrawerContent class="w-[304px] mobile-drawer !p-0">
        <LayoutSidebar
          :rootRouteName="rootRouteName"
          :isMobile="showMobileSidebar"
          @close="showMobileSidebar = false"
        />
      </DrawerContent>
    </Drawer>
  </div>
</template>

<script>
import LayoutHeader from "./LayoutHeader.vue";
import LayoutSidebar from "./LayoutSidebar.vue";
import ClientCabinetMobileHeader from "@/pages/admin/client_cabinet/components/ClientCabinetMobileHeader.vue";
import { Drawer, DrawerContent } from "@/shared/ui/drawer";

export default {
  name: "DefaultLayout",
  components: {
    LayoutHeader,
    LayoutSidebar,
    ClientCabinetMobileHeader,
    Drawer,
    DrawerContent,
  },
  data() {
    return {
      activePageTitle: "",
      showMobileSidebar: false,
    };
  },
  provide() {
    return {
      setActivePageTitle: this.setActivePageTitle,
    };
  },
  computed: {
    rootRouteName() {
      return this.$route.matched[0] && this.$route.matched[0].name;
    },
    hasBreadcrumbs() {
      return this.$route.matched.some(
        (r) => r.name && r.meta && r.meta.isDashboardItem
      );
    },
    navbarSourceRoute() {
      const sourceRoot = [...this.$route.matched]
        .reverse()
        .find((m) => m.meta.sourceRoot);
      if (sourceRoot) {
        const path = this.getFullPath(sourceRoot, []);
        return this.getChildrenRoutes(this.$router.options.routes, path);
      }
      return null;
    },
  },
  methods: {
    getFullPath(route, path) {
      if (route && route.parent) {
        return this.getFullPath(route.parent, [route.name, ...path]);
      }
      return [route.name, ...path];
    },
    getChildrenRoutes(routes, path) {
      const routeName = path.shift();
      const route = routes.find((r) => r.name === routeName);
      if (path.length === 0) {
        return route;
      }
      return this.getChildrenRoutes(route.children, path);
    },
    setActivePageTitle(title) {
      this.activePageTitle = title;
    },
    toggleMobileSidebar() {
      localStorage.setItem("is_sidebar_collapsed", false);
      this.showMobileSidebar = !this.showMobileSidebar;
    },
  },
};
</script>

<style>
.layout {
  display: flex;
  flex: 1 1 auto;
  height: 100%;
  overflow: hidden;
  padding: 0;
  background-color: hsl(var(--background));
}

.layout-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow-y: auto;
  max-width: 100%;
  gap: 20px;
  padding: 16px 24px;
  background-color: hsl(var(--background));
}

.layout-header {
  width: 100%;
}

.layout-main {
  flex: 1 1 auto;
  width: 100%;
  overflow-y: auto;
}

.layout-content .mobile-header {
  display: none;
}

@media (max-width: 900px) {
  .layout {
    padding: 0;
  }

  .layout-sidebar {
    display: none !important;
  }

  .layout-content {
    padding: 12px;
    gap: 12px;
    //background-color: hsl(var(--background));
  }

  .layout-content .mobile-header {
    display: flex;
  }

  .layout-header {
    display: none !important;
  }
}
</style>
